import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ReportUserService } from 'app/services/report-user.service';
import { SelectItem } from 'primeng/api';

@Component({
  selector: 'app-report-user-company-app',
  templateUrl: './report-user-company-app.component.html',
  styleUrls: ['./report-user-company-app.component.css']
})
export class ReportUserCompanyAppComponent implements OnInit {

  @Output() infoReport = new EventEmitter<string>();
  @Output() showInfo = new EventEmitter<boolean>();


  showRoleUserCompanyApp: boolean;
  showUserUserCompanyApp: boolean;
  showCompanyUserCompanyApp: boolean;
  showApplication: boolean;
  showReport: boolean;
  showReportUserCompanyApp: boolean;
  report;

  // Dropdown Source
  roles: SelectItem[] = [];
  roleSelectedUserCompanyApp;

  users: SelectItem[] = [];
  userSelectedUserCompanyApp;

  companies: SelectItem[] = [];
  companySelectedUserCompanyApp;

  applications: SelectItem[] = [];
  applicationSelectedUserCompanyApp;

  constructor(private reportService: ReportUserService, private translate: TranslateService) { }

  ngOnInit() {
    // Ottengo i ruoli da auth e popolo la dropdown
    this.reportService.getAuthRole().subscribe(res => {
      this.roles = res;
    });

    // ottengo gli utenti e popolo la dropdown
    this.reportService.getUsers().subscribe(res => {
      this.users = res;
    });

    // ottengo le company e popolo la dropdown
    this.reportService.getCompanies().subscribe(res => {
      this.companies = res;
    });
    
    // ottengo le application e popolo la dropdown
    this.reportService.getApplications().subscribe(res => {
      this.applications = res;
    });
  }

  reportUserCompanyApplication() {
    if (this.showRoleUserCompanyApp && this.roleSelectedUserCompanyApp == null) {
      this.roleSelectedUserCompanyApp = this.roles[0].value;
    } else if (!this.showRoleUserCompanyApp) {
      this.roleSelectedUserCompanyApp = null;
    }

    if (this.showUserUserCompanyApp && this.userSelectedUserCompanyApp == null) {
      this.userSelectedUserCompanyApp = this.users[0].value;
    } else if (!this.showUserUserCompanyApp) {
      this.userSelectedUserCompanyApp = null;
    }

    if (this.showCompanyUserCompanyApp && this.companySelectedUserCompanyApp == null) {
      this.companySelectedUserCompanyApp = this.companies[0].value;
    } else if (!this.showCompanyUserCompanyApp) {
      this.companySelectedUserCompanyApp = null;
    }

    if (this.showApplication && this.applicationSelectedUserCompanyApp == null) {
      this.applicationSelectedUserCompanyApp = this.applications[0].value;
    } else if (!this.showApplication) {
      this.applicationSelectedUserCompanyApp = null;
    }

    this.showReport = false;
    this.reportService.getReportUserCompanyApp(this.roleSelectedUserCompanyApp, this.userSelectedUserCompanyApp, this.companySelectedUserCompanyApp, this.applicationSelectedUserCompanyApp).subscribe(
      res => {
        this.showReport = true;
        this.report = res;
        this.showReportUserCompanyApp = true;
      });
  }

  openDialog(reportType) {
    this.infoReport.emit(this.translate.instant(`report.${reportType}`));
    this.showInfo.emit(true);
  }

  closeDialogReport() {
    this.showReport = false;
    this.showReportUserCompanyApp = false;
  }



}



// WEBPACK FOOTER //
// ./src/app/views/administration/report-user/report-user-company-app/report-user-company-app.component.ts